import React from "react";

const SideNavbar = ({ children }) => {
    return <div className="w-20 md:w-44">{children}</div>;
};

export default SideNavbar;
